import * as MobileOnly from "@zappar/mobile-only";
import "./scss/index.scss";
import * as payments from "./payments";
import localforage from "localforage";
import { log, logError } from "./utils/logger.js";

import * as Sentry from "@sentry/react";

const isPanorama = import.meta.env.VITE_PANORAMA;
const startPage = document.querySelector(".start-page");

const STORAGE_VERSION = 1;

Sentry.init({
  dsn: "https://e8cad7751ba4208b1574ef136449b1d3@o4507401194373120.ingest.us.sentry.io/4508885304344576",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

async function checkStorageVersion() {
  try {
    const storedVersion = Number(await localforage.getItem("storageVersion"));

    if (isNaN(storedVersion) || storedVersion < STORAGE_VERSION) {
      await localforage.clear();
      await localforage.setItem("storageVersion", STORAGE_VERSION);
    }
  } catch (error) {
    // console.error("Error checking storage version:", error);
  }
}

(async function () {
  try {
    await checkStorageVersion();
    await checkRun();
  } catch (error) {
    logError("An error occurred:", error);
  }
})();

async function checkRun() {
  if (window.location.pathname !== "/") {
    window.history.pushState({}, "", "/");
  }

  // Check for clear parameter in hash
  const hashParams = new URLSearchParams(window.location.hash.slice(1));
  if (hashParams.get("clear") === "true") {
    try {
      await localforage.clear();
      log("Storage cleared due to clear=true parameter");
      // Clear the hash parameter before reload to prevent infinite loop
      window.location.hash = "";
      alert("Cache cleared");
      window.location.reload();
    } catch (error) {
      logError("Error clearing storage:", error);
    }
  }

  if (!startPage) {
    return;
  }

  if (!MobileOnly.isMobile()) {
    startPage.classList.add("hidden");

    MobileOnly.showUI({
      header: "Manpuku-ji Temple",
      instructions: "&nbsp;",
      footer: "&nbsp;",
    });
    return;
  }

  const wrapper = document.querySelector(".wrapper");
  if (wrapper) {
    wrapper.style.height = `${window.innerHeight}px`;
  }

  const startButton = document.querySelector(".start-button");
  if (!startButton) {
    return;
  }

  if (isPanorama === "false") {
    let clicked = false;
    const onClick = async () => {
      if (clicked === true) {
        return;
      }
      clicked = true;

      startButton.classList.add("hidden");

      const empty = new Audio("/data/audio/empty.mp3");
      const p = empty.play();
      p.then(() => {}).catch((e) => {});

      try {
        const status = await payments.checkUUID();
        if (status === "paid") {
          await loadMainApp();
        } else {
          await loadPaymentApp();
        }
      } catch (error) {
        log("Error checking payment status:", error);
        await loadPaymentError();
      }
    };

    startButton.addEventListener("click", onClick);

    // setTimeout(() => {
    //   onClick();
    // }, 500);

    // Check URL for payed parameter
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    if (hashParams.get("paid") === "true") {
      await onClick();
      // Clear URL parameter
      window.location.hash = "";
    } else {
      startButton.classList.remove("hidden");
    }
  } else {
    startButton.classList.add("hidden");
    const { default: WebARApp } = await import("./WebAR/App.js");
    const app = new WebARApp();
    await app.load();
    startPage.classList.add("hidden");
    await app.run();
  }
}

async function loadPaymentError() {
  import("./bootstrapPaymentError").then(({ bootstrapPaymentError }) => {
    startPage.classList.add("hidden");
    bootstrapPaymentError();
  });
}

async function loadPaymentApp() {
  import("./bootstrapPaymentApp").then(({ bootstrapPaymentApp }) => {
    startPage.classList.add("hidden");
    bootstrapPaymentApp();
    // payments.pay();
  });
}

async function loadMainApp() {
  const progress = document.querySelector(".progress");
  if (progress) {
    progress.classList.remove("hidden");
  }

  const progressBarFill = document.querySelector(".progress-bar__fill");
  const progressText = document.querySelector(".progress-text");

  const onLoadProgress = (percent = 0) => {
    if (progressBarFill) {
      progressBarFill.style.width = `${percent}%`;
    }

    if (progressText) {
      progressText.innerText = `${percent}%`;
    }
  };

  const { default: WebARApp } = await import("./WebAR/App.js");
  const webARApp = new WebARApp();
  await webARApp.load(onLoadProgress);
  await webARApp.run();

  import("./bootstrapReact").then(({ bootstrapReact }) => {
    startPage.classList.add("hidden");
    bootstrapReact(webARApp);
  });
}
